import React, { Suspense, useContext, useLayoutEffect } from "react";
import { Route, Switch } from "react-router-dom";
import BookBase from "./bookBase";
import FAQBase from "./FAQBase";
import InitiativeBase from "./InitiativeBase";
import Central from "./central";
import HeartBeat from "./heartBeat";
import Resources from "./resources.jsx";
import Press from "./press.jsx";
import R220301 from "./pressReleases/r220301base";
import "./helpers/i18n";

import "bootstrap";
import customTheme from "./theme";
import ApplicationLayout from "./layout/applicationLayout";
import BackLayout from "./layout/backLayout";

// import Home from "./pages/app/home";
import ComingSoon from "./components/common/comingSoon";
import { ThemeProvider } from "@mui/material";
import { useTranslation } from "react-i18next";
import { LanguageContext } from "./context/language";
import Loader from "./components/common/loader";
import TOU from "./pages/LegalInformation/TOU";
import PP from "./pages/LegalInformation/PP";

const Home = React.lazy(() => import("./pages/app/home"));
const CommonSenseForUnitingAmerica = React.lazy(() =>
  import("./pages/app/commonSenseForUnitingAmerica")
);
const Confirm = React.lazy(() => import("./pages/app/confirm"));
const Revoke = React.lazy(() => import("./pages/app/revoke"));
const Verify = React.lazy(() => import("./pages/app/verify"));

const App = () => {
  const { i18n } = useTranslation();
  const { language } = useContext(LanguageContext);

  useLayoutEffect(() => {
    if (localStorage.getItem("language") !== "") {
      i18n.changeLanguage(localStorage.getItem("language"));
    }
  }, [i18n, language]);

  return (
    <ThemeProvider theme={customTheme}>
      <div className="navi" style={{ overflowX: "hidden" }}>
        <Switch>
          <Route path="/TermsOfUsage" component={TOU} />
          <Route path="/PrivacyPolicy" component={PP} />
          {/* <Route path="/book" component={BookBase} />
          <Route path="/FAQs" component={FAQBase} /> */}
          {/* <Route path="/Initiative" component={InitiativeBase} />
          <Route path="/press220301" component={R220301} />
          <Route path="/press" component={Press} />
          <Route path="/resources" component={Resources} />
          <Route path="/heartBeat" component={HeartBeat} /> */}
          {/* <Route path="/test" component={HeartBeat} /> */}
          {/* /ads.txt is now a real static file in public/ (served as text/plain
              at the domain root, which is the only form Google's crawler accepts).
              The old React route here could never even run: Amplify does not
              rewrite paths with a file extension into the SPA, so the URL 404'd. */}
          <Route path="/coming-soon" component={ComingSoon} />
          <Route path="/confirm">
            <Suspense fallback={<Loader />}>
              <Confirm />
            </Suspense>
          </Route>
          <Route path="/revoke">
            <Suspense fallback={<Loader />}>
              <Revoke />
            </Suspense>
          </Route>
          {/* Printed on every certificate: /verify/{certCode}. Must stay above
              the "/" catch-all or the portal swallows it. The :certCode param is
              optional so a bare /verify still renders the "add your code" note.
              Verify reads it via useParams, which is basename-aware — swarmage.net
              serves the app under a /maxvoting basename. */}
          <Route path="/verify/:certCode?">
            <Suspense fallback={<Loader />}>
              <Verify />
            </Suspense>
          </Route>
          {/* <Route path="/old-ui" component={Central} /> */}
          {/* <Route path="/election-science">
            <Suspense fallback={<Loader />}>
              <BackLayout>
                <Route
                  path="/election-science"
                  component={CommonSenseForUnitingAmerica}
                />
              </BackLayout>
            </Suspense>
          </Route> */}
          <Route path="/">
            <Suspense fallback={<Loader />}>
              <BackLayout>
                <Route
                  path="/"
                  component={CommonSenseForUnitingAmerica}
                />
              </BackLayout>
            </Suspense>
          </Route>

          {/* <Route path="/">
            <Suspense fallback={<Loader />}>
              <ApplicationLayout>
                <Route path="/" component={Home} />
              </ApplicationLayout>
            </Suspense>
          </Route> */}
        </Switch>
      </div>
    </ThemeProvider>
  );
};

export default App;
